export default "__VITE_ASSET__XhbmizrZ__"